// extracted by mini-css-extract-plugin
module.exports = {"navFooterItem":"socialMediaNavLink-module--navFooterItem--XgEk_","cell":"socialMediaNavLink-module--cell--2IgSP","text":"socialMediaNavLink-module--text--2p2EC"};